import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { generateSaEngineProjectionForClient, type ProjectionResponseDto, type SaEngineRequestData } from '../../generated/client';
import { queryKeys } from '../../query-keys';
import { useProjectionSetup } from './use-projection-setup';

export function useProjection(projectionPeriodInYears?: number): UseQueryResult<ProjectionResponseDto, AxiosError> {
    const { data: client } = useClient();
    const projectionSetup = useProjectionSetup(projectionPeriodInYears, client);

    return useQuery({
        queryKey: queryKeys.projection(client?.partnerUuid, projectionSetup.body),
        queryFn: ({ queryKey }) =>
            generateSaEngineProjectionForClient({ path: { clientId: client!.id }, body: queryKey[3] as SaEngineRequestData }).then((result) => result.data),
        enabled: projectionSetup.enabled,
    });
}
